module.exports = __webpack_public_path__ + "static/media/profile.f431aeed.svg";